import { render } from "./BandoengLogo.vue?vue&type=template&id=635acbe6"
import script from "./BandoengLogo.vue?vue&type=script&lang=js"
export * from "./BandoengLogo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__